import { db } from './config';
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
  query,
  orderBy,
  where,
} from 'firebase/firestore';

// --- Contacto ---
// Guarda el lead con todos los campos que el admin panel necesita leer.
// Nunca guardes undefined: si un campo opcional está vacío, guarda ''.
export const enviarContacto = async (datos) => {
  return addDoc(collection(db, 'contactos'), {
    nombre:    datos.nombre    || '',
    email:     datos.email     || '',
    telefono:  datos.telefono  || '',
    servicio:  datos.servicio  || '',
    mensaje:   datos.mensaje   || '',
    estado:    'pendiente',
    fechaEnvio: serverTimestamp(),
  });
};

// --- Actualizar estado de un contacto ---
export const actualizarEstadoContacto = async (id, nuevoEstado) => {
  const ref = doc(db, 'contactos', id);
  return updateDoc(ref, {
    estado: nuevoEstado,
    fechaActualizacion: serverTimestamp(),
  });
};

// --- Eliminar un contacto ---
export const eliminarContacto = async (id) => {
  return deleteDoc(doc(db, 'contactos', id));
};

// --- Obtener todos los contactos (para el admin) ---
export const obtenerContactos = async () => {
  const q = query(
    collection(db, 'contactos'),
    orderBy('fechaEnvio', 'desc')
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

// --- Doctores ---
export const obtenerDoctores = async () => {
  const q = query(
    collection(db, 'doctors'),
    where('activo', '==', true),
    orderBy('orden', 'asc')
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

// --- Testimonios ---
export const obtenerTestimonios = async () => {
  const snap = await getDocs(collection(db, 'testimonials'));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};